<template>
    <div v-bind:class="checkSchedule" class="schedule-compact">
        <a v-if="(checkDelay()) && scheduleMobile && !checkSchedule.block" class="schedule-content" :href="'tel:' + this.experienceContent.phone">
            <div class="schedule-image">
                <img v-if="this.getDesign() == 'black'" src="./../assets/phone_dark.png" alt="white phone">
                <img v-else src="./../assets/phone_white.png" alt="black phone">
            </div>
            <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
        </a>
        <div v-else-if="checkDelay() && scheduleDesktop && !checkSchedule.block" class="schedule-content" @click="openModal = !openModal">
            <div class="schedule-image">
                <img v-if="this.getDesign() == 'black'" src="./../assets/phone_dark.png" alt="white phone">
                <img v-else src="./../assets/phone_white.png" alt="black phone">
            </div>
            <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
        </div>
        <div class="schedule-content" v-else-if="checkPassDay()">
            <div class="schedule-image">
                <img src="./../assets/clock_ocupada.png" alt="occupied clock">
            </div>
            <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
        </div>
        <div class="schedule-content" @click="selectSchedule(checkSchedule.block)" v-else>
            <div class="schedule-image">
                <img v-if="!checkFree() || checkSchedule.block" src="./../assets/clock_ocupada.png" alt="">
                <img v-else-if="this.getDesign() == 'black'" src="./../assets/clock_dark.png" alt="">
                <img v-else src="./../assets/clock_white.png" alt="">
            </div>
            <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
        </div>
        <small v-if="placesLeft && checkSchedule.free" class="places-left">{{ $tc('placesLeft', placesLeft, { n: placesLeft }) }}</small>

        <div v-if="openModal" class="modal-call" @click="openModal = !openModal">
            <div class="modal-call-center">
                {{ $t('callTo') }} {{ this.experienceContent.phone }} {{ $t('callTo2') }}
            </div>
        </div>
    </div>
</template>

<script>

    import schedule from './../schedule';

    export default {
        extends: schedule,
        name: 'schedule-compact'
    };

</script>

<style lang="scss" scoped>
    @import "schedule-compact";
</style>